<app-device-features-container
  header="{{ title | translate }}"
  [overlayType]="overlayType"
  [deviceSelectId]="deviceSelectId"
>
  <ng-container feature *ngIf="gasConsumptionSummaryHeating">
    <app-feature-tile
      feature
      value="{{ gasConsumptionSummaryHeating | value2: featurePropertyKey.currentDay }} {{
        gasConsumptionSummaryHeating | unit: featurePropertyKey.currentDay
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_CURRENT_DAY' | translate }}"
    ></app-feature-tile>
  </ng-container>
  <ng-container feature *ngIf="gasConsumptionSummaryDhw">
    <app-feature-tile
      feature
      value="{{ gasConsumptionSummaryDhw | value2: featurePropertyKey.currentDay }} {{
        gasConsumptionSummaryDhw | unit: featurePropertyKey.currentDay
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.DHW_CURRENT_DAY' | translate }}"
    ></app-feature-tile>
  </ng-container>
  <ng-container feature *ngIf="powerConsumptionSummaryHeating">
    <app-feature-tile
      feature
      value="{{ powerConsumptionSummaryHeating | value2: featurePropertyKey.currentDay }} {{
        powerConsumptionSummaryHeating | unit: featurePropertyKey.currentDay
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.HEATING_CURRENT_DAY' | translate }}"
    ></app-feature-tile>
  </ng-container>
  <ng-container feature *ngIf="powerConsumptionSummaryDhw">
    <app-feature-tile
      feature
      value="{{ powerConsumptionSummaryDhw | value2: featurePropertyKey.currentDay }} {{
        powerConsumptionSummaryDhw | unit: featurePropertyKey.currentDay
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.DHW_CURRENT_DAY' | translate }}"
    ></app-feature-tile>
  </ng-container>
  <ng-container feature *ngIf="autarkySummary">
    <app-feature-tile
      feature
      value="{{ autarkySummary | value2: featurePropertyKey.current }} {{
        autarkySummary | unit: featurePropertyKey.current
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_DAY' | translate }}"
    ></app-feature-tile>
    <app-feature-tile
      feature
      value="{{ autarkySummary | value2: featurePropertyKey.lastSevenDays }} {{
        autarkySummary | unit: featurePropertyKey.lastSevenDays
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_SEVEN_DAYS' | translate }}"
    ></app-feature-tile>
    <app-feature-tile
      feature
      value="{{ autarkySummary | value2: featurePropertyKey.currentMonth }} {{
        autarkySummary | unit: featurePropertyKey.currentMonth
      }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.CURRENT_MONTH' | translate }}"
    >
    </app-feature-tile>
    <app-feature-tile
      feature
      value="{{ autarkySummary | value2: featurePropertyKey.lastMonth }}
    {{ autarkySummary | unit: featurePropertyKey.lastMonth }}"
      label="{{ '+INSTALLATIONS.INSTALLATION.GENERIC_CONSUMPTION.LAST_MONTH' | translate }}"
    ></app-feature-tile>
  </ng-container>
</app-device-features-container>
